import { Component , OnInit} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-account-lock',
  standalone: true,
  imports: [],
  templateUrl: './account-lock.component.html',
  styleUrl: './account-lock.component.scss'
})
export class AccountLockComponent implements OnInit {

  constructor(
    private bsModalRef: BsModalRef
  ){
  }
  ngOnInit() {
    
  }
  close(){
    this.bsModalRef.hide();
  }
}
